import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class MEFOrder extends DexResourceModel {

    @Field(Number)
    public totalFees: number | null = 0;

    @Field(Number)
    public advancedFees: number | null = 0;

    @Field(Number)
    public otherFees: number | null = 0;

    @Field(Number)
    public updatedFees: number | null = 0;

    @Field(String)
    public sourceVendorId: string = '';

    @Field(String)
    public sourceVendorStatus: string = '';

    @Field(Boolean)
    public orderClosed: boolean = false;

    @Field(String)
    public order_uuid: string | null = '';

    @Field(Number)
    public lcOrderMappingId: number = 0;


    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
